import { defineMessages } from "react-intl";

const messages = defineMessages({
  applyDraft: {
    id: "email.creation.draftsModal.applyDraft",
    defaultMessage: "Apply Draft",
    description: "Manage email drafts modal - Apply Draft",
  },
  applyDraftDisabledBecauseOfResourcesTooltip: {
    id: "email.creation.draftsModal.applyDraftDisabledBecauseOfResourcesTooltip",
    defaultMessage: "Remove resources without access to apply this draft",
    description: "Manage email drafts modal - Apply draft disabled because of resources tooltip",
  },
  clickToOpenTooltip: {
    id: "email.creation.draftsModal.clickToOpenTooltip",
    defaultMessage: "Click to open record",
    description: "Manage email drafts modal - Click to open tooltip",
  },
  deleteDraft: {
    id: "email.creation.draftsModal.deleteDraft",
    defaultMessage: "Delete Draft",
    description: "Manage email drafts modal - Delete draft",
  },
  draftDeleted: {
    id: "email.creation.draftsModal.deleteSuccessMessage",
    defaultMessage: "Draft deleted",
    description: "Manage email drafts modal - Draft deleted",
  },
  draftDeleteErrorDescription: {
    id: "email.creation.draftsModal.draftDeleteErrorDescription",
    defaultMessage: "Please try again or contact support.",
    description: "Manage email drafts button - Draft delete error description",
  },
  draftDeleteErrorMessage: {
    id: "email.creation.draftsModal.draftDeleteErrorMessage",
    defaultMessage: "Error deleting draft",
    description: "Manage email drafts button - Draft delete error message",
  },
  draftDeleteSuccessMessage: {
    id: "email.creation.draftsModal.draftDeleteSuccessMessage",
    defaultMessage: "Draft deleted",
    description: "Manage email drafts button - Draft delete success message",
  },
  drafts: {
    id: "email.creation.draftsModal.drafts",
    defaultMessage: "Email Drafts",
    description: "Manage email drafts modal - Drafts",
  },
  draftSaveShortDateFormat: {
    id: "email.creation.draftsModal.draftSaveShortDateFormat",
    defaultMessage: "MMM d",
    description: "Manage email drafts modal - Draft save short date format",
  },
  emailNotFound: {
    id: "email.creation.draftsModal.emailNotFound",
    defaultMessage: "Email Not Found",
    description: "Manage email drafts modal - Email not found",
  },
  noSubject: {
    id: "email.creation.draftsModal.noSubject",
    defaultMessage: "(No Subject)",
    description: "Manage email drafts modal - No subject",
  },
  recordNotFound: {
    id: "email.creation.draftsModal.recordNotFound",
    defaultMessage: "Record Not Found",
    description: "Manage email drafts modal - Record not found",
  },
  removeInvalidResourcesAlertSuffix: {
    id: "email.creation.draftsModal.removeInvalidResourcesAlertSuffix",
    defaultMessage: "They will need to be removed before applying.",
    description: "Manage email drafts modal - Remove invalid resources alert suffix",
  },
  resourcesRemoved: {
    id: "email.creation.draftsModal.resourcesRemoved",
    defaultMessage: "Resource(s) removed",
    description: "Manage email drafts modal - Resources removed",
  },
  someRecipientsNotFoundAlert: {
    id: "email.creation.draftsModal.someRecipientsNotFoundAlert",
    defaultMessage:
      "Some recipients on this draft have been deleted or you no longer have access to the records. These recipients will not be included.",
    description: "Manage email drafts modal - Some recipients not found alert",
  },
  someRecipientsNotFoundOrWithoutEmailAlert: {
    id: "email.creation.draftsModal.someRecipientsNotFoundOrWithoutEmailAlert",
    defaultMessage:
      "<p>Some recipients on this draft:</p><ul><li>do not have associated email addresses</li><li>do not have records accessible to you or have been deleted</li></ul><p>These recipients will not be included.</p>",
    description: "Manage email drafts modal - Some recipients without email alert",
  },
  someRecipientsWithoutEmailAlert: {
    id: "email.creation.draftsModal.someRecipientsWithoutEmailAlert",
    defaultMessage:
      "Some recipients on this draft do not have associated email addresses and will not be included.",
    description: "Manage email drafts modal - Some recipients without email addresses alert",
  },
  toLabel: {
    id: "email.creation.draftsModal.toLabel",
    defaultMessage: "To:",
    description: "Manage email drafts modal - To label",
  },
  undo: {
    id: "email.creation.draftsModal.undo",
    defaultMessage: "Undo",
    description: "Manage email drafts modal - Undo",
  },
});

export default messages;
